import React from 'react'
import BookingPage from '../components/BookingPage'
import MiniHeader from '../components/MiniHeader'

const Booking = () => {
  return (
    <>
    <MiniHeader title={"Booking Trip"} />
    <BookingPage />
    </>
  )
}

export default Booking
